<template>
    <div id="menu-create-group" class="w-100">
        <link rel="stylesheet" href="https://fonts.googleapis.com/css2?family=Material+Symbols" />
        <div class="header w-100 d-flex align-items-center justify-content-between">
            <div class="back-button" @click="backButton()">
                <span class="material-symbols-outlined">
                    arrow_back
                </span>
            </div>

            <div v-if="title.length" class="title">
                <span>{{ title }}</span>
            </div>

            <!-- <div class="hamburguer-menu">
                <span class="material-symbols-outlined">
                    more_vert
                </span>
            </div> -->

        </div>

        <div id="group-info" class="tab active" data-tab="group-info">

            <div class="upload-group-img d-flex w-100 justify-content-center py-24">

                <div class="group-image">

                    <div class="thumb-icon d-flex justify-content-center align-items-center" @click="uploadStart">
                        <input accept=".jpg,.png" type="file" name="group-thumb" id="group-thumb" ref="group-thumb" style="display: none;" @change="upload">
                        <div v-if="thumb.length" class="thumb-container">
                            <div class="thumb" :style="`background: url(${thumb});`">
                            </div>
                        </div>
                        <div v-else>
                            <span  class="material-symbols-outlined landscape-icon">
                                landscape
                            </span>
                            <div class="upload d-flex align-items-center justify-content-center">
                                <span class="material-symbols-outlined upload-icon">
                                    upload
                                </span>
                            </div>
                        </div>
                    </div>


                </div>
            </div>

            <div class="label-create-group d-flex justify-content-center">
                <span>{{ localData.length == 0 ? $t('notification.group.create_group') : $t('notification.group.group_edit') }}</span>
            </div>

            <form class="ui form py-24" id="group-form" @submit.prevent>
                <!-- <input v-model="localData.thumb_id" type="hidden" name="thumb_id" id="thumb_id" ref="thumb_id"> -->
                <div class="field name">
                    <label>{{ $t("notification.group.name") }}</label>
                    <input v-model="localData.name" type="text" name="name" ref="group_name" :placeholder="$t('notification.group.enter_name')">
                </div>

                <div class="field description">
                    <label>{{ $t("notification.group.description") }}</label>
                    <textarea v-model="localData.description" rows="6" name="description" :placeholder="$t('notification.group.enter_description')"></textarea>
                </div>
            </form>


            <!-- <div v-if="localData.length != 0" class="group-members d-flex align-items-center justify-content-between">

                <div class="d-flex flex-column">
                    <span class="members-count">{{ $tc('notification.group.members_added', getSelectedUsersCount(), { count: getSelectedUsersCount() } ) }}</span>
                    <span>{{ $t('notification.group.start_add_members') }}</span>
                </div>

                <div class="btn-add-group-member d-flex align-items-center justify-content-center" @click="changeTab('add-members')">

                    <span class="material-symbols-outlined upload-icon">
                        person_add
                    </span>

                </div>
            </div> -->

            <div class="group-members d-flex align-items-center justify-content-between">

                <div class="d-flex flex-column">
                    <span class="members-count">{{ $tc('notification.group.members_added', getSelectedUsersCount(), { count: getSelectedUsersCount() } ) }}</span>
                    <span>{{ $t('notification.group.start_add_members') }}</span>
                </div>

                <div class="btn-add-group-member d-flex align-items-center justify-content-center" @click="changeTab('add-members')">

                    <span class="material-symbols-outlined upload-icon">
                        person_add
                    </span>

                </div>
            </div>


            

            <div class="btn-actions py-24 d-flex align-items-center justify-content-between gap-4">
            <div class="btn-cancel flex-grow-1 d-flex justify-content-center" @click="btnCancel()">
                <span>{{ $t('notification.group.cancel') }}</span>
            </div>
            <div class="btn-save flex-grow-1 d-flex justify-content-center" @click="btnSave()">
                <span>{{ $t('notification.group.save') }}</span>
            </div>
        </div>

        </div>

        <div id="add-members" class="tab" data-tab="add-members">

            <div class="search-add d-flex align-items-center justify-content-between gap-3 py-3">
                <div class="ui icon input flex-grow-1">
                    <!-- <input type="text" :placeholder="$t('notification.group.search')" @input="handleSearchUserInput()" v-model="searchUserInput"> -->
                    <input type="text" :placeholder="$t('notification.group.search')" @keypress="handleSearchUserInput" v-model="searchUserInput">
                    <span class="material-symbols-outlined search-icon" @click="handleSearchUserInput">
                        search
                    </span>
                </div>
            </div>

            <div class="list-users">

                <template v-if="listUsersFiltered.length">
                    <div class="user d-flex align-items-center justify-content-between py-2" v-for="user in listUsersFiltered" :key="user.id">
                        <!-- <pre>{{ user }}</pre> -->
                        <div class="d-flex align-items-center gap-3">
                            <div class="thumb-container">
                                <div class="thumb" :style="`background: url(${user.profile_photo_url});`">
                                </div>
                            </div>
                            <span>{{ user.name }}</span>
                        </div>
                        <div v-if="user.id != localData.user_id">
                            <div v-if="user.selected" class="add-user" @click="toggleUserSelection(user)">
                                <div class="d-flex align-items-center justify-content-center align-items-center gap-2">
                                    <span class="material-symbols-outlined person-add-icon">
                                        person_add
                                    </span>
                                    <span class="label">{{ $t('notification.group.add') }}</span>
                                </div>
                            </div>
                            <div v-else class="remove-user" @click="toggleUserSelection(user)">
                                <div class="d-flex align-items-center justify-content-center align-items-center gap-2">
                                    <span class="material-symbols-outlined person-remove-icon">
                                        person_remove
                                    </span>
                                    <span class="label">{{ $t('notification.group.remove') }}</span>
                                </div>
                            </div>
                        </div>

                    </div>
                    <Pagination v-if="listUsers.length" :chunk="listN" :total="totalUsers"></Pagination>
                </template>
                <template v-else>
                    <div class="h-100 d-flex flex-column justify-content-center align-items-center gap-2">
                        <span class="material-symbols-outlined search-icon">
                            search_off
                        </span>
                        <span class="no-results">{{ $t('notification.group.no_results') }}</span>
                        <span class="no-user-found">{{ $t('notification.group.no_user_found') }}</span>
                    </div>
                </template>

            </div>

            <!-- <div class="save-members d-flex justify-content-center py-3">
                <div class="btn-save text-center">
                    <span>{{ $t('notification.group.save') }}</span>
                </div>
            </div> -->

        </div>
    </div>
</template>

<script>
    import axios from 'axios';
    import { mapGetters} from "vuex";
    import Pagination from './Pagination.vue';

    let emitter = require('tiny-emitter/instance');

    export default {
        name: "MenuCreateGroup",
        props: {
            data: [],
        },
        components: {
            Pagination
        },
        watch: {
            data(newValue, oldValue) {
                console.log("MenuCreateGroup watch data: ", newValue, oldValue);
                this.localData = newValue;
            }
        },
        data() {
            return {
                title: "",
                // thumb: 'https://api-local.virtual.town/storage/53/user_profile_picture/a812aa48b334986305a02df92ce293691730928779.png'
                thumb: '',
                searchUserTimeout: null,
                searchUserInput: '',
                listUsersFiltered: [],
                currentTab: 'group-info',
                isGroupOwner: false,
                totalUsers: 0,
                listN: 7,
                listUsers: [
                    // {
                    //     thumb: 'https://api-local.virtual.town/storage/53/user_profile_picture/a812aa48b334986305a02df92ce293691730928779.png',
                    //     name: 'Username 1',
                    //     id: 1,
                    //     selected: false
                    // }
                ],
                localData: this.data
            }
        },
        beforeMount() {
            // sort listUsers alphabetically
            // this.listUsers = this.sortAlphabeticcally(this.listUsers);
            // this.listUsersFiltered = this.listUsers.map(user => user);
            if (this.localData.thumbnail)
            {
                this.thumb = this.localData.thumbnail;
            }
            this.prepareUserList();
        },
        mounted() {
            console.log("MenuCreateGroup mounted: ", this.localData);

            this.isGroupOwner = this.id === this.localData.user_id;

            let vm = this;

            emitter.on("Chat::open::group::users_list", function(data) {
                vm.getAllUsers(data);

                console.log('##### Chat::open::group::users_list => ', data);
            });

            // vm.getAllUsers({ page:0 });
        },
        methods: {
            userAtFirstPosition(users) {

            const userIndex = users.findIndex(user => user.id === this.id);

            const [user] = users.splice(userIndex, 1);
            users.unshift(user);

            return users;

            },
            getAllUsers(data)
            {
                let headers_ = { 'Content-Type': 'application/json;charset=UTF-8', 'Access': 'application/json', language: this.$i18n.locale, Authorization: `Bearer ${this.token}` };
                let params_ = data;
                params_['listN'] = this.listN;

                // this.listUsers= [];
                // this.totalUsers = 0;
                // this.listUsersFiltered = [];

                axios.get(this.$url_api + 'api/pm/load/all-users', { params: params_, headers: headers_ })
                    .then(response => {
                      
                        // console.log('###### ixeeeeeeeeeeee => ', this.localData.users);
                        for (let o in response.data.data.users)
                        {
                            const index = this.localData.users ? this.localData.users.filter(user_ => user_.id === response.data.data.users[o].id) : [];
                            response.data.data.users[o].selected = index.length == 0 ? true : false;
                        }

                        this.listUsers = response.data.data.users;
                        this.totalUsers = response.data.data.total;

                        this.listUsers = this.sortAlphabeticcally(this.listUsers);
                        this.listUsers = this.userAtFirstPosition(this.listUsers);
                        this.listUsersFiltered = this.listUsers.map(user => user);

                        console.log(this.totalUsers, this.listUsers);
                    })
                    .catch(error => {
                        console.log('##### error => ', error);
                    
                    })
                    // .finally(response => {
                    //     response;
                        
                    // });
            },
            prepareUserList() {
                try
                {
                    //aqui juligo
                    // this.listUsers = this.sortAlphabeticcally(this.localData.users);
                    // this.listUsers = this.userAtFirstPosition(this.listUsers);
                    // this.listUsersFiltered = this.listUsers.map(user => user);
                    // console.log(this.listUsersFiltered);
                }
                catch(e) { e; }
            },
            sortAlphabeticcally(list) {
               return list.sort((a, b) => {
                   return a.name.localeCompare(b.name);
               });
            },
            toggleUserSelection(user) {
                console.log("toggleUserSelection: ", user);

                //adiciona/remove usuário
                let data = {
                    event_id: this.event_id
                };

                console.log('##### add/remove user => ', this.localData);

                let headers = { 'Content-Type': 'application/json;charset=UTF-8', 'Access': 'application/json', language: this.$i18n.locale, Authorization: `Bearer ${this.token}` };
                if (!user.selected)
                {
                    axios.delete(this.$url_api + 'api/pm/group/' + this.localData.id + '/user/' + user.id, { params: data, headers:headers })
                    .then(response => {
                        response.data.group;
                        console.log('#### add/remove user response => ', response);
                        //Chat::open::edit_group
                        emitter.emit('Chat::open::edit_group', { groupDetails: response.data.data.group });

                        window.$.toast({
                            title: 'OK!',
                            message: this.$t('notification.group.removed_user'),
                            class: 'success',
                            showIcon: 'check',
                            showProgress: 'top'
                        });
                    })
                    .catch(error => {
                        // console.log('##### error add/remove user => ', error.response.data.errors)

                        let st = '';
                        for (let o in error.response.data.data)
                        {
                            st += (error.response.data.data[o] + '<br>');
                        }

                        window.$.toast({
                            // title: 'Erro!',
                            message: st,
                            class: 'error',
                            showIcon: 'times',
                            showProgress: 'top'
                        });
                    });
                }
                else
                {
                    axios.post(this.$url_api + 'api/pm/group/' + this.localData.id + '/user/' + user.id, data, { headers:headers })
                    .then(response => {
                        response;
                        console.log('#### add/remove user response => ', response);
                        emitter.emit('Chat::open::edit_group', { groupDetails: response.data.data.group });

                        window.$.toast({
                            // title: 'OK!',
                            message: this.$t('notification.group.added_user'),
                            class: 'success',
                            showIcon: 'check',
                            showProgress: 'top'
                        });
                    })
                    .catch(error => {

                        // Remove the user with the specified ID
                        const find = this.listUsersFiltered.find(u => u.id === user.id);
                        if (find) {
                            find.selected = true;
                        }

                        // console.log('##### error add/remove user => ', error.response.data.errors)
                        let st = '';
                        for (let o in error.response.data.data)
                        {
                            st += (error.response.data.data[o] + '<br>');
                        }

                        window.$.toast({
                            // title: 'Erro!',
                            message: st,
                            class: 'error',
                            showIcon: 'times',
                            showProgress: 'top'
                        });
                    
                    });
                }
                

                
                // Atualiza a lista principal
                this.listUsers = this.listUsers.map(u =>
                    u.id === user.id ? { ...u, selected: !u.selected } : u
                );

                this.listUsersFiltered = this.listUsers;

                // Atualiza a lista filtrada
                // this.listUsersFiltered = [
                //     ...this.sortAlphabeticcally(this.listUsers.filter(user => user.selected)),
                //     ...this.sortAlphabeticcally(this.listUsers.filter(user => !user.selected)),
                // ];
                

                console.log(this.listUsersFiltered);
                
            },
            getSelectedUsersCount() {
                // return this.listUsers.filter(user => user.selected).length;
                // return this.listUsers.length;
                return (this.localData && this.localData.users) ? this.localData.users.length : 0;
            },
            handleSearchUserInput(e) {
                console.log("handleSearchUserInput");
                if (e.keyCode == 13)
                    this.getAllUsers({page:0, search: e.currentTarget.value})


                /*
                let vm = this;

                clearTimeout(vm.searchUserTimeout);

                vm.searchUserTimeout = setTimeout(function() {
                    if(vm.searchUserInput.length >= 3 || vm.searchUserInput.length === 0) {

                        vm.listUsersFiltered = vm.listUsers.filter(user => {
                           return user.name.toLowerCase().includes(vm.searchUserInput.toLowerCase());
                        });
                    }
                }, 700);
                */
            },
            backButton() {
                console.log("backButton currentTab: ", this.currentTab);

                if(this.currentTab === 'add-members') {
                    this.changeTab('group-info');
                    return;
                }

                emitter.emit('MenuCreateGroup::backButton', { tab: 'tabInbox'});

            },
            errorHandler(error)
            {
                window.$.toast({
                    position: 'top right',
                    title: this.$i18n.t('resetpassword.erro'),
                    message: error,
                    showProgress: 'bottom',
                    classProgress: 'white',
                    className: {
                        toast: ' ui toast transparent-toast'
                    },
                    displayTime: 6000,
                    showIcon: 'times',
                    closeOnClick: true
                });
            },
            uploadStart() {
                document.getElementById('group-thumb').click();
            },
            upload(e) {
                if (this.$refs['group-thumb'].files.length)
                {
                    /*
                    let headers = { 'Content-Type': 'application/json;charset=UTF-8', 'Access': 'application/json', language: this.$i18n.locale, Authorization: `Bearer ${this.token}` };
                    let form_data = new FormData();
                    form_data.append('file', this.$refs['group-thumb'].files[0]);
                    axios.post(this.$url_api + 'api/lms/user/files/upload', form_data, { headers:headers })
                    .then(response => {
                        response;

                        console.log('#### upload response => ', response);
                        // this.btnSave();
                    })
                    .catch(error => {
                        console.log('error', error.response.data.errors)
                    
                    })
                    .finally(response => {
                        response;
                        
                    });
                    */
                    
                    const vm = this;
                    const file = e.target.files[0];  // Pega o primeiro arquivo selecionado
                    if (file) {
                        const reader = new FileReader();  // Usado para ler o conteúdo do arquivo
                        reader.onload = function(e) {
                            // Cria um elemento de imagem e define o conteúdo para o arquivo lido
                            // const imgElement = document.getElementById('thumbnail');
                            // imgElement.src = e.target.result;  // O conteúdo da imagem lida
                            vm.thumb = e.target.result

                        };
                        reader.readAsDataURL(file);  // Lê o arquivo como uma URL (Base64)
                    }
                }
                /*
                else
                {
                    this.errorHandler(this.$t('notification.group.error_file'));
                    // this.btnSave();
                }
                */
            },
            
            btnCancel() {
                console.log("btnCancel");

                this.backButton();
            },
            btnSave() {
                this.$parent.$parent.wait(true);
                if (this.$refs['group-thumb'].files.length)
                {
                    let headers = { 'Content-Type': 'application/json;charset=UTF-8', 'Access': 'application/json', language: this.$i18n.locale, Authorization: `Bearer ${this.token}` };
                    let form_data = new FormData();
                    form_data.append('file', this.$refs['group-thumb'].files[0]);
                    axios.post(this.$url_api + 'api/lms/user/files/upload', form_data, { headers:headers })
                    .then(response => {
                        response;

                        console.log('#### upload response => ', response);
                        this.save(response);
                    })
                    .catch(error => {
                        console.log('error', error.response.data.errors)
                        // console.log('##### error add/remove user => ', error.response.data.errors)
                        let st = '';
                        for (let o in error.response.data.data)
                        {
                            st += (error.response.data.data[o] + '<br>');
                        }

                        window.$.toast({
                            // title: 'Erro!',
                            message: st,
                            class: 'error',
                            showIcon: 'times',
                            showProgress: 'top'
                        });
                    
                    })
                    .finally(response => {
                        response;
                        
                    });
                    
                }
                else
                    this.save(null);
                
            },
            save (response) {
                response;
                let headers = { 'Content-Type': 'application/json;charset=UTF-8', 'Access': 'application/json', language: this.$i18n.locale, Authorization: `Bearer ${this.token}` };
                let form_data = new FormData(document.getElementById('group-form'));
                form_data.append('event_id', this.event_id);
                form_data.append('thumb_id', (response != null) ? response.data.data.file.id : (this.localData.thumb_id ? this.localData.thumb_id : ""));
                console.log('######## response save ==> ', response);
                // if (response != null)
                // {
                //     this.localData.thumb_id = response.data.data.file.id;

                //     console.log('######## this.localData ==> ', this.localData);
                // }
                    
                // form_data.append('thumb_id', (response != null) ? response.data.data.file.id : "");

                // console.log('#### aqui meu amigo => ', response.data.data.file.id, ((response != null) ? response.data.data.file.id : ""));
                // this.localData.thumb_id = ((response != null) ? response.data.data.file.id : "");
                // this.$refs['thumb_id'].value = ((response != null) ? response.data.data.file.id : "");

                let object = {};
                form_data.forEach(function(value, key){
                    object[key] = value;
                });
                // var json = JSON.stringify(object);

                axios[this.localData.id ? 'put' : 'post'](this.$url_api + 'api/pm/group' + (this.localData.id ? ('/' + this.localData.id) : ''), object, { headers:headers })
                .then(response => {
                    response;
                    console.log('##### save data => ', this.localData, response.data.data.group);
                    

                    if (this.localData.id)
                        this.backButton();
                    else
                    {
                        let currentData = response.data.data.group;
                        currentData.users = [];

                        this.$parent.data = currentData;
                        this.localData = currentData;
                        // this.$forceUpdate();

                        let vm = this;
                        setTimeout(() => {
                            console.log(11111111111111111111111111111111111);

                            this.title = this.$t('notification.group.add_members');
                            this.getAllUsers({page:0});

                            const element = document.querySelector(`[data-tab="${vm.currentTab}"]`);

                            // find all divs with data-tab
                            const tabs = document.querySelectorAll('.tab');
                            // remove active class from all tabs
                            tabs.forEach(tab => tab.classList.remove('active'));
                            // add active at element
                            element.classList.add('active');

                            // vm.$parent.showView = "details-edit-group";
                            // console.log('group_id =>', this.localData.id);

                            // emitter.emit('Chat::open::edit_group', { groupDetails: vm.data});
                        }, 100);
                        
                    }

                    this.$parent.$parent.wait(false);
                })
                .catch(error => {
                    console.log('error', error.response.data.data)
                    // let st = '';
                    // for (let o in error.response.data.errors)
                    // {
                    //     st += error.response.data.errors[o] + '<br>';
                    // }
                    // this.errorHandler(st);
                    let st = '';
                    for (let o in error.response.data.data.errors) {
                        st += (error.response.data.data.errors[o] + '<br>');
                    }
                    window.$.toast({
                        // title: 'Erro!',
                        message: st,
                        class: 'error',
                        showIcon: 'times',
                        showProgress: 'top'
                    });
                    this.$parent.$parent.wait(false);
                })
                .finally(response => {
                    response;
                });
            },
            changeTab(tab) {
                console.log("changeTab: ", tab, this.localData);

                this.currentTab = tab;

                if(tab === 'add-members')
                {
                    if ((!this.localData.id) && (this.$refs['group_name'].value.length < 2))
                    {
                        //juligo aqui
                        console.log('juligoq aqui')
                        window.$.toast({
                            title: 'Erro!',
                            message: this.$t('notification.group.info_create_group_name'),
                            class: 'error',
                            showIcon: 'check',
                            showProgress: 'top'
                        });
                        return;
                    }
                    else if ((!this.localData.id) && (this.$refs['group_name'].value.length >= 2))
                    {  
                        this.btnSave();
                        return;
                    }
                }

                

                const element = document.querySelector(`[data-tab="${tab}"]`);

                // find all divs with data-tab
                const tabs = document.querySelectorAll('.tab');
                // remove active class from all tabs
                tabs.forEach(tab => tab.classList.remove('active'));
                // add active at element
                element.classList.add('active');

                if(tab === 'add-members') {

                    
            
                    this.title = this.$t('notification.group.add_members');
                    this.getAllUsers({page:0});
                } else if (tab == 'group-info') {
                    this.title = '';
                    console.log('### entrou aqui mesmo');
                }
            }
        },
        computed: {
            ...mapGetters([
                'id', 'token', 'event_id'
            ])
        },
        beforeDestroy() {
            console.log("MenuCreateGroup beforeDestroy");
            emitter.off('Chat::open::group::users_list');
        }
    }
</script>

<style scoped lang="scss">

#menu-create-group {
    max-height: 702px;

    .header {

        .title {
            font-family: Open Sans, sans-serif;
            font-size: 20px;
            font-weight: 700;
            line-height: 27px;
            text-align: center;

        }

        .back-button {
            cursor: pointer;
        }

        .material-symbols-outlined {
            font-variation-settings:
                'FILL' 1,
                'wght' 400,
                'GRAD' 0,
                'opsz' 24
        }

        .hamburguer-menu {
            cursor: pointer;
        }
    }

    .upload-group-img {

        .group-image {
            position: relative;
            cursor: pointer;

            .thumb-icon {

                width: 90px;
                height: 90px;
                background-color: #F1F1F1;
                border-radius: 50%;

            }

            .landscape-icon {
                color: #D8D8D8;
            }

            .upload {
                width: 28px;
                height: 28px;
                background-color: #11BF03;
                border-radius: 100px;
                position: absolute;
                top: 5px;
                right: -5px;

                .upload-icon {
                    font-size: 16px;
                    line-height: 24px;
                    color: #FFFFFF;
                }

            }

            .thumb-container {


                .thumb {
                    width: 90px;
                    height: 90px;

                    border-radius: 54px;
                    position: relative;
                    background-size: cover !important;
                    background-position: center !important;
                    background-repeat: no-repeat !important;
                    background-blend-mode: saturation;

                }
            }
        }
    }

    .label-create-group {
        span {
            font-family: Open Sans, sans-serif;
            font-size: 20px;
            font-weight: 700;
            line-height: 27px;
            color: #393939;

        }
    }

    form.ui.form {

        .name {
        }

        label {
            font-family: Open Sans, sans-serif;
            font-size: 16px;
            font-weight: 600;
            line-height: 22px;
            color: #393939;
        }

        input, textarea {
            border-radius: 10px;
            font-family: Open Sans, sans-serif;
            font-size: 16px;
            font-weight: 400;
            line-height: 24px;
            color: #3939394D;
        }

    }

    .group-members {
        .members-count {
            font-family: Open Sans, sans-serif;
            font-size: 16px;
            font-weight: 600;
            line-height: 21.79px;
            text-align: left;
            text-underline-position: from-font;
            text-decoration-skip-ink: none;

        }

        .btn-add-group-member {
            cursor: pointer;
            width: 52px;
            height: 44px;
            background-color: #EBE2BE;
            border-radius: 10px;
            color: #323232;
            font-size: 20px;
            font-weight: 400;
            line-height: 24px;

            .upload-icon {
                font-family: 'Material Icons';
                font-size: 20px;
                font-weight: 400;
                line-height: 24px;


                font-variation-settings:
                    'FILL' 1,
                    'wght' 400,
                    'GRAD' 0,
                    'opsz' 24
            }

        }
    }

    .btn-actions {

        span {
            font-family: Exo, sans-serif;
            font-size: 16px;
            font-weight: 600;
            line-height: 21px;
        }

        .btn-cancel {
            cursor: pointer;
            border-radius: 10px;
            border: 1px solid #11BF03;
            padding: 11px 14px;

            span {
                color: #11BF03;
            }
        }

        .btn-save {
            cursor: pointer;
            border-radius: 10px;
            background-color: #11BF03;
            padding: 11px 14px;

            span {
                font-family: Exo, sans-serif;
                font-size: 16px;
                font-weight: 600;
                line-height: 21px;
                color: #FFFFFF;
            }
        }

    }


    .tab {
        display: none;

        &.active {
            display: block;
        }

    }

    #add-members {

        height: 500px;

        .search-add {

            .ui.icon.input {
                position: relative;
                input {
                    border-radius: 10px;
                }

                .search-icon {
                    cursor: pointer;
                    position: absolute;
                    width: 16px;
                    height: 16px;
                    color: var(--buttons_color);
                    right: 25px;
                    top: 22.5%;
                }
            }
        }

        .list-users {

            height: 100%;

            .search-icon {
                color: #B1B1B1;
                font-weight: 400;
                font-size: 32px;
                line-height: 24px;


                font-variation-settings:
                    'FILL' 1,
                    'wght' 400,
                    'GRAD' 0,
                    'opsz' 24
            }
            .no-results {
                font-family: Open Sans, sans-serif;
                font-size: 16px;
                font-weight: 600;
                line-height: 24px;
                color: #696A70;
            }
            .no-user-found {
                font-family: Open Sans, sans-serif;
                font-size: 16px;
                font-weight: 400;
                line-height: 24px;
                color: #696A70;
            }

            .add-user, .remove-user {

                border: 1px solid var(--buttons_color);
                border-radius: 10px;
                cursor: pointer;
                padding: 11px 14px;

                .label {
                    font-family: Exo, sans-serif;
                    font-size: 14px;
                    font-weight: 600;
                    line-height: 19px;
                }

            }

            .add-user {
                background-color: var(--buttons_color);
                color: #FFFFFF;

                .person-add-icon {
                    font-family: 'Material Icons';
                    font-size: 20px;
                    font-weight: 400;
                    line-height: 24px;
                    color: #FFFFFF;

                    font-variation-settings:
                        'FILL' 1,
                        'wght' 400,
                        'GRAD' 0,
                        'opsz' 24
                }
            }

            .remove-user {

                color: var(--buttons_color);

                .person-remove-icon {
                    font-family: 'Material Icons';
                    font-size: 20px;
                    font-weight: 400;
                    line-height: 24px;

                    font-variation-settings:
                        'FILL' 1,
                        'wght' 400,
                        'GRAD' 0,
                        'opsz' 24
                }
            }

            .thumb {
                width: 42px;
                height: 43px;
                border-radius: 54px;
                position: relative;
                background-size: cover !important;
                background-position: center !important;
                background-repeat: no-repeat !important;
                background-blend-mode: saturation;

            }

            .users-container {
            }


            overflow-y: scroll; /* ou auto para adicionar rolagem apenas quando necessário */
            -ms-overflow-style: none; /* Para ocultar no Internet Explorer e Edge */
            scrollbar-width: none; /* Para ocultar no Firefox */

            &::-webkit-scrollbar {
                display: none; /* Para ocultar no Chrome, Safari e Opera */
            }

        }

        .save-members {

            .btn-save {
                width: 164px;
                height: 43px;
                background-color: var(--buttons_color);
                color: #FFFFFF;
                padding: 11px 14px;
                border-radius: 10px;

            }

        }

    }


    .py-32 {
        padding-top: 32px !important;
        padding-bottom: 32px !important;
    }

    .py-24 {
        padding-top: 15px !important;
        padding-bottom: 15px !important;
    }



}

</style>